import React, { Component } from 'react'
import moment from 'moment'

const Info = props => {
    let { paymentData } = props
    let {
        recipient_name,
        recipient_address,
        amount,
        currency,
        amount_cpt,
        description,
        currency_rate_fix_upto_datetime,
        payment_id,
    } = paymentData
    let translation = JSON.parse(localStorage.translation)[
        localStorage.language
    ]

    return (
        <div className="payment__box payment__box_left">
            <div>
                <h2 className="payment__desc payment__desc_blue payment__text-size_m payment__margin-bottom_m">
                    Depository.Payment
                </h2>
                <p className="payment__text-size_x">
                    {recipient_name[0].toUpperCase() + recipient_name.slice(1)}
                </p>
                <p className="payment__desc payment__margin-bottom_s payment__text-ofh">
                    {recipient_address}
                </p>
                <p
                    className={
                        currency !== 'CPT'
                            ? 'payment__text-size_m'
                            : 'payment__text-size_m payment__margin-bottom_s'
                    }
                >{`${amount} ${currency}`}</p>
                {currency !== 'CPT' ? (
                    <p className="payment__desc payment__margin-bottom_s">
                        {`${amount_cpt} CPT`}
                    </p>
                ) : null}
                <p>{`${translation['Description']}:`}</p>
                <p className="payment__desc payment__margin-bottom_x payment__desc_mw40">
                    {description}
                </p>
            </div>
            <div className="payment__row">
                {currency !== 'CPT' && currency_rate_fix_upto_datetime > 0 ? (
                    <p className="payment__desc">
                        {`* Exchange rate ${currency} to CPT is
                            fixed up to
                            ${moment
                                .unix(currency_rate_fix_upto_datetime)
                                .format('YYYY-MM-DD H:mm:ss')}
                            UTC`}
                    </p>
                ) : null}
                <p className="payment__desc">{`* ${
                    translation['Order ID']
                }: ${payment_id}`}</p>
            </div>
        </div>
    )
}

export default Info
